module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/A_K_Q@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/A_K_Q@3x.png
// module id = 703
// module chunks = 0